import { render, staticRenderFns } from "./ConsultorChat.vue?vue&type=template&id=48fa6108&scoped=true"
import script from "./ConsultorChat.vue?vue&type=script&lang=js"
export * from "./ConsultorChat.vue?vue&type=script&lang=js"
import style0 from "./ConsultorChat.vue?vue&type=style&index=0&id=48fa6108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa6108",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VChip,VIcon,VNavigationDrawer,VProgressLinear,VSpacer,VTextarea,VToolbar,VToolbarTitle})
